// extracted by mini-css-extract-plugin
export default {"header":"CharacteristicsList_header__KdU0n","radioGroup":"CharacteristicsList_radioGroup__uA8LI","scrollable":"CharacteristicsList_scrollable__7EiSy"};